import { render } from "./App.vue?vue&type=template&id=2e927be2"
const script = {}

import "./App.vue?vue&type=style&index=0&id=2e927be2&lang=less"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__